import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import DriverApp from './driver/DriverApp';
import SignedInApp from './SignedInApp';

/**
 * Vozač ide iz adrese (`?vozac=<id>`), svi ostali kroz prijavu.
 *
 * Ranije je i poslovođa dolazio iz adrese, `?mpo=<sifra>` — pa je svako ko zna
 * šifru otvarao tuđu prodaju. Sada objekat dolazi uz nalog, ne uz link.
 *
 * Vozač ostaje po starom jer njegov telefon radi bez mreže i bez kucanja po
 * hladnoći; njemu pristup ide ključem u linku, a to je sledeći korak.
 */
const parameters = new URLSearchParams(window.location.search);

// Ključ, ne redni broj: sa brojem je svako ko zna adresu video tuđu turu sa
// imenima kupaca, adresama i telefonima.
//
// Dovoljno je da parametar POSTOJI. Star link (`?vozac=3`) tako završi na
// vozačevom ekranu koji mu kaže da traži nov — ranije je tiho padao na
// operaterovu prijavu, pa je vozač mislio da je aplikacija pukla.
const driverKey = parameters.get('vozac')?.trim() ?? '';
const isDriver = parameters.has('vozac');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    {isDriver ? <DriverApp accessKey={driverKey!} /> : <SignedInApp />}
  </React.StrictMode>
);

// Servisni radnik postoji samo zbog vozača: bez njega se aplikacija ne bi ni
// otvorila kad telefon nema signal, pa bi cela offline priča pala na prvom
// gašenju pregledača.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => {
      console.warn('Offline režim nije dostupan.', e);
    });
  });
}
